import React from 'react';
import { IconContainer } from '../../iconContainer';
import { mergeSx } from '../../../../../utils/sx/merge';
import { AvatarTokens } from '../../../const';
import { AvatarIconContentProps } from './model';
import { ICON_SIZE_TO_CONTAINER_SIZE } from './const';

export const AvatarIconContent: React.FC<AvatarIconContentProps> = ({ theme, backgroundColor, icon: Icon, iconProps }) => {
  const iconSize = `calc(${AvatarTokens.Size('100px')} * ${ICON_SIZE_TO_CONTAINER_SIZE})`;

  return (
    <IconContainer
      sx={{
        backgroundColor,
      }}
      theme={theme}
    >
      <Icon
        {...iconProps}
        sx={mergeSx(
          {
            height: iconSize,
            maxHeight: iconSize,
            maxWidth: iconSize,
            width: iconSize,
          },
          iconProps?.sx,
        )}
      />
    </IconContainer>
  );
};
